import React, { useState, useRef } from 'react';
import { SelectAdCampaignProps } from './campaignSettingsFormModels';
import { ChevronDownIcon, InfoIcon } from '../../../../assets';
import { CampaignPlatformDropdownConfig } from '../../../../config/CampaignsConfig';
import useOutsideClick from '../../../../hooks/useOutsideClicks';
import { useAuth } from '../../../../context/AuthContext';
import { Tooltip, InfoModal } from '../../../../components';
import { useAppData } from '../../../../context/AppContext';

const SelectCampaignAdPlatform: React.FC<SelectAdCampaignProps> = ({
  formikValues,
  setFormikValues,
  errors,
  setFieldValue,
  isCampaignDisabled,
  handleClearAds,
}) => {
  const { currentUser } = useAuth();
  const { setShowModalBackground } = useAppData();
  const [isPlatformDropdownOpen, setIsPlatformDropdownOpen] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const currentSubscription = currentUser?.subscription;
  const planName = currentSubscription?.subscriptionPlan?.name || 'Free';
  const isFreePlan = planName === 'Free';

  const adPlatformDropdown = useRef<HTMLDivElement>(null);
  const excludeOutsideClickRef = useRef<HTMLDivElement>(null);

  useOutsideClick(
    adPlatformDropdown,
    () => setIsPlatformDropdownOpen(false),
    excludeOutsideClickRef
  );

  const togglePlatformDropdown = () => {
    setIsPlatformDropdownOpen((prevState) => !prevState);
  };

  const handleChangePlatform = (value: string) => {
    setFormikValues((prevState) => ({
      ...prevState,
      platforms: [value], // replace the entire platforms array with the new value
    }));
    handleClearAds();
    setIsPlatformDropdownOpen(false);
  };

  return (
    <div className="d-flex-start-start w-100 p-relative mb-1rem">
      <div className="d-flex-row">
        <label className="campaign-label-input">
          Communication Channel Selection
        </label>
        <div className="d-flex-center icon-hovered ml-0_5rem pb-0_5rem">
          <Tooltip
            tooltipText="Pick the messaging platform your campaign will use— SMS, or other."
            tooltipWidth={250}
          />
        </div>
      </div>
      <div
        className={`${errors?.platforms && !isCampaignDisabled && 'error'
          } ${isCampaignDisabled ? 'opacity-0_7' : 'pointer'} d-flex-row campaign-input w-100`}
        onClick={() =>
          !isCampaignDisabled ? togglePlatformDropdown() : () => { }
        }
        ref={excludeOutsideClickRef}
      >
        <span>{formikValues?.platforms[0]}</span>
        <div className="d-flex-center p-absolute right-0_625rem top-2_8rem">
          <ChevronDownIcon
            className={`${isPlatformDropdownOpen && 't-rotate-180'}`}
          />
        </div>
      </div>

      {errors?.platforms && !isCampaignDisabled && (
        <div className="form-error">{errors?.platforms}</div>
      )}
      {isPlatformDropdownOpen && (
        <div
          className="p-absolute z1 w-100 overflow-auto max-h-15rem top-4_5rem bg-white shadow-box-12"
          ref={adPlatformDropdown}
        >
          {CampaignPlatformDropdownConfig.map((option, index) => {
            // Check if SMS should be disabled for the current user
            /*const isSMSDisabled = option === 'SMS'; &&
              currentUser?.subscription?.subscriptionPlan?.name !==
                'Pro Monthly';*/
            const isFacebookDisabled = false;
            const isInstagramDisabled = option === 'Instagram';

            return (
              <div
                key={index}
                className={`${option === formikValues?.platforms[0] ? 'bg-badge' : ''} d-flex-center-start h-2_375rem bb-1 ${
                  /*!isSMSDisabled || */ !isFacebookDisabled ||
                    !isInstagramDisabled
                    ? ''
                    : ''
                  }`}
                onClick={() => {
                  // Prevent SMS from being clickable if disabled
                  if (option === 'SMS' && isFreePlan) {
                    setShowModalBackground(true);
                    setShowPremiumModal(true);
                    return;
                  }

                  if (
                    option === 'SMS' ||
                    option === 'Meta Messaging' ||
                    option === 'Instagram'
                  ) {
                    handleChangePlatform(option);
                    setFieldValue('platforms', [option]);
                  }
                }}
              >
                <div className="d-flex-row-space-between w-100 pr-0_5rem">
                  <span
                    className={`pl-0_5rem fs-0_875rem ${(option === 'Meta Messaging' && isFacebookDisabled) ||
                      (option === 'Instagram' && isInstagramDisabled)
                      ? 'c-secondary'
                      : 'f-roboto-m-primary'
                      }`}
                  >
                    {option}
                  </span>
                  {option === 'SMS' && isFreePlan && (
                    <div className="bg-fef3c7 p-0_125rem-0_375rem b-radius-0_25rem">
                      <span className="ff-inter fw-600 fs-0_625rem c-92400e">
                        ★
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {showPremiumModal && (
        <div className="d-flex-center p-fixed top-0 left-0 size-max z4">
          <InfoModal
            title="The SMS platform is not included in your plan. Please upgrade to access."
            onClose={() => {
              setShowPremiumModal(false);
              setShowModalBackground(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SelectCampaignAdPlatform;
